<!-- #2818 modified by ngx-extended-pdf-viewer -->
<div id="editorModeButtons" class="splitToolbarButton toggled">
  <!-- #3257 modified by ngx-extended-pdf-viewer -->
  <pdf-signature-properties [show]="showSignaturePropertiesButton()"></pdf-signature-properties>
  <!-- #3257 end of modification by ngx-extended-pdf-viewer -->
  <pdf-comment-editor [show]="showCommentEditor()" [disable]="disableCommentEditor()"></pdf-comment-editor>
  <pdf-editor-signature [show]="showSignatureEditor()" [disable]="disableSignatureEditor()"></pdf-editor-signature>
  <pdf-highlight-editor [show]="showHighlightEditor()" [disable]="disableHighlightEditor()"></pdf-highlight-editor>
  <pdf-text-editor [show]="showTextEditor()" [disable]="disableTextEditor()"></pdf-text-editor>
  <pdf-stamp-editor [show]="showStampEditor()" [disable]="disableStampEditor()"></pdf-stamp-editor>
  <pdf-draw-editor [show]="showDrawEditor()" [disable]="disableDrawEditor()"></pdf-draw-editor>
  <!-- stephanrauh/pdf.js#14 modified by ngx-extended-pdf-viewer - the eraser -->
  @if (showEraserEditor() !== false) {
    <pdf-eraser-editor [show]="showEraserEditor()" [disable]="disableEraserEditor()"></pdf-eraser-editor>
  }
  <!-- stephanrauh/pdf.js#14 end of modification by ngx-extended-pdf-viewer -->
</div>
<!-- #2818 end of modification by ngx-extended-pdf-viewer -->